/***********************/
/* Angular + external */
import { Component, ElementRef } from "@angular/core";
import { Observable, Subject } from "rxjs";
/***********************/
/* BFX */
// models
import { BfxDialogData } from "./models/bfx-dialog-data.model";
// components
import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";
// services

import { BfxSysConfigUtilService } from "shared/auth-services";
import { AlgoStrategyLookupService, SystemConfigPromiseService } from "shared/cubiq-services";
import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-dialog-auto-hedge-status-change.component",
  templateUrl: "./html/bfx-dialog-auto-hedge-status-change.html",
  standalone: false,
})
export class BfxAutoHedgeStatusChangeComponent extends BfxDialogBaseComponent {
  public data = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,

    dialogData: {
      show: false,
      width: 500,
      title_text: "Auto Hedge - Circuit breaker",
      currentlyOn: true,
      targetStateString: "Off",
      comment: "",
      placeholder: "Comment",
    },

    body: null,
  };

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */
  constructor(
    private _element: ElementRef,
    public sysConfigService: SystemConfigPromiseService,
    protected algoStrategyLookupService: AlgoStrategyLookupService,
    protected sysConfigUtil: BfxSysConfigUtilService,
  ) {
    super();
  }

  public openDialog(_dialogData: BfxDialogData): Observable<any> {
    logger.out.info("openDialog");

    this.data.dialogId = _dialogData.dialogId;
    this.data.body = _dialogData.body;
    this.data.payload = _dialogData.payload;
    NativeDesktopSupport.prepareEmbeddedDialog(this.data.body, this._dialog, this._element);

    this.data.dialogData.targetStateString = this.data.payload.currentState == true ? "Off" : "On";
    this.data.dialogData.show = true;

    return this.data.dialogEventSubject.asObservable();
  }

  public closeDialog(): void {
    logger.out.info("closeDialog");
    super.closeDialog();

    this.data.actionEvent = null;
    this.data.payload = null;
    this.data.dialogData.show = false;

    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
  }

  public actionYes(): void {
    logger.out.info("actionYes");
    if (this.data.payload.callback) {
      this.data.payload.callback(this.data.actionEvent, this.data.dialogData.comment);
    }
    this.closeDialog();
  }

  public actionNo(): void {
    logger.out.info("actionNo");
    if (this.data.payload.callbackNegative) {
      this.data.payload.callbackNegative(this.data.actionEvent);
    }
    this.closeDialog();
  }
}
